import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowCornerDownLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconArrowCornerDownLeft"><Path fillRule="evenodd" clipRule="evenodd" d="M19.4142 4V14H6.82843L9.82843 11L8.41421 9.58579L3 15L8.41421 20.4142L9.82843 19L6.82843 16H21.4142V4H19.4142Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowCornerDownLeft;
